import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db, getDocument } from "../../../Firebase";
import "./EtudiantDasbord.css";
import CardCoursEtudiant from './CardCoursEtudiant'
import PaginationContainer from "../../../Component/PaginationContainer/PaginationContainer";

function EtudiantDasbord() {
  const [userCurrent, setUserCurrent] = useState({});
  const currentUserId = sessionStorage.getItem("user_id");
  const reftabCours = query(collection(db, "cours"));
  const [myCours, setMyCours] = useState([]);

  const getUsers = () => {
    onSnapshot(reftabCours, (item) => {
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });
      setMyCours(data);
    });
  };

  useEffect(() => {
    getUsers();
    getDocument("users", currentUserId, setUserCurrent);
  }, [currentUserId]);

  const [searchTerm, setSearchTerm] = useState("");
  const handelChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const allCourses = myCours.filter(
    (item) =>
      item.isArchived === false &&
      item.isApproved === true &&
      item.domaine.toLowerCase() === userCurrent.domaine.toLowerCase() &&
      item.admin_id === userCurrent.admin_id
  );
  const filteredDatas = allCourses.filter(
    (elt) =>
      elt?.titre_cours?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      elt?.description?.toLowerCase().includes(searchTerm?.toLowerCase())
  );
  const myDatas = searchTerm === "" ? allCourses : filteredDatas; 

  console.log({ allCourses });
  return (
    <div className="etudiant-dasord container-fluid px-md-5 px-sm-5 mt-3">
      <div className="d-flex mb-2 justify-content-end ajouRecher">
        <input
          type="text"
          onChange={handelChange}
          value={searchTerm}
          className="form-control w-25"
          placeholder="Recherche cours"
        />
      </div>

      <Row>
        <PaginationContainer data={myDatas} ItemComponent = {CardCoursEtudiant} />
      </Row>
    </div>
  );
}

export default EtudiantDasbord;
